import { useEffect, useRef } from 'react';

/**
 * Custom hook for creating portals
 * @param id The ID of the root HTML Element
 */
var usePortal = function usePortal(id) {
  var rootElemRef = useRef(document.createElement('div'));
  useEffect(function () {
    var parentElem = document.querySelector("#".concat(id));
    var ref = rootElemRef.current;
    if (parentElem) {
      parentElem.appendChild(ref);
    }
    return function removeElement() {
      ref.remove();
    };
  }, []);
  return rootElemRef.current;
};
export default usePortal;